import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import authReducer from "./user/reducers/auth.reducer";
import customizationReducer from "./layout/reducers/customization.reducer";
import boardReducer from "./board/reducers/board.reducer";
import groupReducer from "./group/reducers/group.reducer";
import taskReducer from "./task/reducers/task.reducer";
import userReducer from "./user/reducers/user.reducer";
import desktopReducer from "./desktop/reducers/desktop.reducer";
import accountReducer from "./accounts/reducers/account.reducer";
import dashboardReducer from "./dashboard/reducers/dashboard.reducer";
import notificationReducer from "./notifications/reducers/notifications.reducers"
import planReducer from "./plans/reducers/plan.reducer";
import memberGroupReducer from "./memberGroups/reducers/memberGroup.reducer";

import logger from "redux-logger";
import { debug } from "./middlewares/debug";

// Configuração de persistência modularizada
const persistConfig = { storage };

const authPersistConfig = { ...persistConfig, key: "auth" };
const customizationPersistConfig = { ...persistConfig, key: "customization" };
const boardPersistConfig = { ...persistConfig, key: "board" };
const groupPersistConfig = { ...persistConfig, key: "groups" };
const desktopPersistConfig = { ...persistConfig, key: "desktops" };
const accountPersistConfig = { ...persistConfig, key: "accounts" };
const notificationsPersistConfig = { ...persistConfig, key: "notifications" };
const planPersistConfig = { ...persistConfig, key: "plan" };

// Reducers persistidos
// const rootReducer = combineReducers({
//   auth: persistReducer(authPersistConfig, authReducer),
//   customization: persistReducer(customizationPersistConfig, customizationReducer),
//   board: persistReducer(boardPersistConfig, boardReducer),
//   groups: persistReducer(groupPersistConfig, groupReducer),
//   //tasks: persistReducer(taskPersistConfig, taskReducer),
//   tasks: taskReducer,
//   user: userReducer,
//   desktops: persistReducer(desktopPersistConfig, desktopReducer),
//   accounts: persistReducer(accountPersistConfig, accountReducer),
//   dashboard: dashboardReducer,
//   notifications: persistReducer(notificationsPersistConfig, notificationReducer),
//   plan: persistReducer(planPersistConfig, planReducer),
// });
const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  customization: persistReducer(customizationPersistConfig, customizationReducer),
  board: boardReducer,
  groups: groupReducer,
  //tasks: persistReducer(taskPersistConfig, taskReducer),
  tasks: taskReducer,
  user: userReducer,
  desktops: persistReducer(desktopPersistConfig, desktopReducer),
  accounts: persistReducer(accountPersistConfig, accountReducer),
  dashboard: dashboardReducer,
  notifications: notificationReducer,
  plan: persistReducer(planPersistConfig, planReducer),
  memberGroups: memberGroupReducer,
});

// Middleware só aplicado em ambiente de desenvolvimento
const middlewares = [];
// if (process.env.NODE_ENV === "development") {
//   middlewares.push(logger);
// }


// Configuração do store
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middlewares), // concat(debug), para debugar pelo redux ### alterar o arquivo debug para escolher oq debugar
  devTools: {
    maxAge: 10,
    trace: false,
  },
});



const persistor = persistStore(store);

export { store, persistor };